<section class="tw-flex tw-flex-col tw-justify-between tw-min-h-[200px] tw-py-6 tw-px-4">
  <section class="tw-flex tw-justify-center tw-items-start tw-mb-6">
    <p class="tw-text-main-text tw-text-xl tw-font-[Rubik] tw-text-center">{{text}}</p>
  </section>

  <section class="tw-flex tw-justify-center tw-items-end {{ isMobile ? 'tw-gap-2' : 'tw-gap-5'}}">
    <mh-core-lib-button
        [isSecondary]="true"
        [text]="'commons.cancel' | translate"
        [width]="isMobile ? 120 : 160"
        (clicked)="handleButtonClick('CANCEL')"
        ></mh-core-lib-button>
    <mh-core-lib-button
        [isPrimary]="true"
        [text]="'commons.accept' | translate"
        [width]="isMobile ? 120 : 160"
        (clicked)="handleButtonClick('ACCEPT')"
        ></mh-core-lib-button>
  </section>
</section>
